import type { ReactNode } from 'react';
import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonSpinner,
  IonText,
} from '@ionic/react';

interface NetworkListProps {
  loading: boolean;
  hasError: boolean;
  errorMessage: string;
  /** Number of rows loaded so far. */
  count: number;
  hasMore: boolean;
  onLoadMore: (event: CustomEvent<void>) => void;
  emptyMessage: ReactNode;
  /** Line above the rows (e.g. the number of results). */
  heading?: ReactNode;
  children: ReactNode;
}

// Loading, error, empty and infinite-scroll states shared by the listings of
// the "Red" tab and the career organization page.
export const NetworkList = ({
  loading,
  hasError,
  errorMessage,
  count,
  hasMore,
  onLoadMore,
  emptyMessage,
  heading,
  children,
}: NetworkListProps) => {
  if (loading && count === 0) {
    return (
      <div className="flex min-h-[200px] items-center justify-center">
        <IonSpinner name="crescent" />
      </div>
    );
  }

  if (hasError && count === 0) {
    return (
      <IonText color="danger">
        <p>{errorMessage}</p>
      </IonText>
    );
  }

  if (count === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-[#cfd5df] bg-white p-5 text-center">
        <p className="m-0 text-sm text-slate-500">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <>
      {heading && <p className="m-0 mb-3 px-1 text-sm font-semibold text-gray-700">{heading}</p>}
      {children}
      {hasMore && (
        <IonInfiniteScroll onIonInfinite={onLoadMore} threshold="100px">
          <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Cargando más..." />
        </IonInfiniteScroll>
      )}
    </>
  );
};
